import { Box, Grid, Typography } from "@mui/material";
import { ICatalogOffer } from "@features/cart/ICart";
import { OfferPrice } from "@common/OfferPrice/OfferPrice";
import broadbandPlan from "@static/img/home/broadbandPlanDrawer.png";
import { useStyle } from "./homeBroadbandSidePanelPrequalStyle";
import { useTranslation } from "react-i18next";
import { BRAND_NAME } from "@constants";
import { Prequal } from "@features/prequal/Prequal";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";
import { HomeBroadbandWhyBlock } from "@features/home/broadband/HomeBroadbandWhyBlock";
import CheckIcon from "@static/icons/CheckRounded.svg";
import PaperPlaneIcon from "@static/icons/PaperPlane.svg";
import RocketIcon from "@static/icons/Rocket.svg";
import HeartIcon from "@static/icons/Heart.svg";
import { useDeviceType } from "@hooks/useDeviceType";
import { getOfferPrice } from "@utils/offerUtils";

interface IParams {
    offer: ICatalogOffer;
    setPrequal(prequal: IEirSalesPrequal | undefined): void;
}

export const HomeBroadbandSidePanelPrequal = (props: IParams) => {
    const { offer, setPrequal } = props;
    const { t } = useTranslation("home");
    const { classes } = useStyle();

    const { isMobile } = useDeviceType();

    return (
        <div className={classes.container}>
            <img alt="Broadband plan" className={classes.image} src={broadbandPlan} />
            <Box paddingBlock={3} paddingInline={isMobile ? 2 : 4}>
                <Typography color="secondary" maxWidth={400} variant="h2">
                    {t("interestedInBroadband", { brand: BRAND_NAME })}
                </Typography>
                <Grid alignItems="center" container paddingY={3} spacing={2}>
                    <Grid item xs={7}>
                        <Typography color="secondary" fontWeight={450} variant="h3">
                            {offer.usages[0]?.description}
                        </Typography>
                    </Grid>
                    <Grid display="flex" item justifyContent="flex-end" xs={5}>
                        <OfferPrice price={getOfferPrice(offer)} priceColor="#33A1A9" priceFontSize="32px" />
                    </Grid>
                </Grid>
                <Prequal isSidePanel isWrapped setPrequal={setPrequal} />
            </Box>
            <div className={classes.containerDark}>
                <div className={classes.marketing}>
                    <Typography align="center" variant="h2">
                        {t("broadbandWhy.title")}
                    </Typography>
                    <div className={classes.inlineContainer}>
                        <HomeBroadbandWhyBlock
                            description={t("broadbandWhy.priceForLife.description")}
                            isCompactLayout
                            svgIcon={CheckIcon}
                            title={t("broadbandWhy.priceForLife.title")}
                        />
                        <HomeBroadbandWhyBlock
                            description={t("broadbandWhy.experienceFreedom.description")}
                            isCompactLayout
                            svgIcon={PaperPlaneIcon}
                            title={t("broadbandWhy.experienceFreedom.title")}
                        />
                        <HomeBroadbandWhyBlock
                            description={t("broadbandWhy.reliableNetwork.description")}
                            isCompactLayout
                            svgIcon={RocketIcon}
                            title={t("broadbandWhy.reliableNetwork.title")}
                        />
                        <HomeBroadbandWhyBlock
                            description={t("broadbandWhy.goMoFamily.description")}
                            isCompactLayout
                            svgIcon={HeartIcon}
                            title={t("broadbandWhy.goMoFamily.title")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
